export const PREFIX = "possible";
export const INPUT_INFOUSER_NAME = [
  "customer_document_type",
  "customer_document_number",
  "customer_firstname",
  "customer_middlename",
  "customer_lastname",
  "customer_second_lastname",
  "customer_email",
  "customer_number_phone",
];

export const BODY_BRANDS = ["1", "3"];

export const fnValidationRequest = (req) => {
  // typeof {} and typeof [] they are 'object'
  // if req.data.length is undefined is a object
  const validateData =
    req?.data?.length === undefined
      ? Object.keys(req?.data)?.length !== 0 // object
      : req?.data?.length !== 0; // array

  const validateStatus = [200, "success"].includes(req.status);
  return Boolean(validateStatus && validateData);
};
